import { ThemeOptions } from '@mui/material/styles/createTheme';
import { typography } from './typography';

export enum ThemeMode {
  LIGHT = 'light',
  DARK = 'dark',
}

export const commonThemeOptions: ThemeOptions = {
  zIndex: {
    drawer: 2400,
    modal: 2500,
    snackbar: 2600,
    tooltip: 2700,
  },
  typography,
  // ##TODO, This is not being honoured, create a bug to MUI.
  components: {
    MuiAutocomplete: {
      defaultProps: {
        componentsProps: { paper: { elevation: 8 } },
      },
    },
  },
};

export const THEME_MODE_STORAGE_KEY = 'themeMode';

export const DARK_THEME_USER_TAG = 'dark-theme';

export const ENABLED_DARK_THEME_FOR_OLD_USER =
  'enabled-dark-theme-for-old-user';

export const THEME_MODE_QUERY_PARAM = 'themeMode';
